export { default as ListadosPT } from "./ListadosPT";

